import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { APIErrorResponse, AttentionTask, AttentionTaskStatus } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { QUERY_KEYS } from '@/constants'

export type UsePatchAttentionTaskProps = {
  target_type: AttentionTask['target_type']
  target_id: number
}

export type PatchAttentionTaskData = {
  id: number
  status?: AttentionTaskStatus
  rework_message?: string
}

export const usePatchAttentionTask = ({
  target_type,
  target_id,
}: UsePatchAttentionTaskProps): UseMutationResult<
  AttentionTask,
  APIErrorResponse,
  PatchAttentionTaskData
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()

  return useMutation(
    (data: PatchAttentionTaskData) =>
      client
        .patch(`plannings/attention_tasks/${data.id}/`, data)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([
          QUERY_KEYS.ATTENTION_TASKS,
          target_type,
          target_id,
        ])
      },
    }
  )
}
